import styled from 'styled-components';

export const FieldLabel = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  margin: 0;
`;

export const FieldLabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 16px 0 4px 0;
`;

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  padding: 16px;
  gap: 8px;
`;

export const Title = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 20px;
  font-weight: 500;
  line-height: 150%;
  margin: 0;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 12px;
  margin: 0;
`;

export const Section = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  border-radius: 8px;
  margin-bottom: 10px;
  background: ${({ theme }) => theme.palette.common.white};
`;

export const SectionContainer = styled.div`
  display: flex;
  flex: 1;
  background: ${({ theme }) => theme.palette.common.white};
  padding: 10px 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

export const SectionContainerHeader = styled.div<{ $expanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: ${({ $expanded, theme }) => ($expanded ? `1px solid ${theme.palette.grey[300]}` : null)};
  background: ${({ theme }) => theme.palette.common.white};
  border-radius: 8px;
  border-bottom-left-radius: ${(props) => (props.$expanded ? 0 : '8px')};
  border-bottom-right-radius: ${(props) => (props.$expanded ? 0 : '8px')};
`;

export const StageGuidanceContainer = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  background: ${({ theme }) => theme.palette.common.white};
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 12px 0;
`;

export const StageName = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.15px;
  margin: 0;
  padding: 16px 16px 0 16px;
`;

export const SectionTitle = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  padding: 0;
`;

export const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  border-radius: 8px;
  margin: 8px 0;
`;

export const Header = styled.div<{ $expanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  display: flex;
  padding: 12px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: ${({ $expanded }) => ($expanded ? '8px 8px 0 0' : '8px')};
  border-bottom: ${({ $expanded, theme }) => ($expanded ? `1px solid ${theme.palette.grey[300]}` : 'none')};
  background: ${({ theme }) => theme.palette.grey[100]};
`;

export const FieldName = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 12px;
  font-weight: 500;
  margin: 0;
  padding: 0;
`;
